import {Component, Input, OnInit} from '@angular/core';
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import {DiagramService} from "@app/workflow-common/diagram-view2/services/diagram.service";
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {INodeOptions, NodeOptionsObject} from "@app/workflow-common/diagram-view2/models/node.model";
import {Subject} from "rxjs";

@Component({
    selector: 'app-audit-history2',
    templateUrl: './audit-history2.component.html',
    styleUrls: ['../instance-history/instance-history.component.scss']
})
export class AuditHistory2Component implements OnInit {

    isLoading:boolean = true;
    noData: boolean = true;
    isLoadingDiagramView: boolean = false;
    currentPage:number = 1;
    pageLimit:number = 20;
    totalEntriesCount: number = 0;
    auditItems: any[] = [];
    param:object = {};
    fields: any = {};
    infiniteScrollOn: boolean = false;
    selectedItem:object = undefined;
    activeDagData: {} = undefined;
    nodeOptions: INodeOptions;
    filterOptions: any[] = [];
    appliedViewsFilter: any[] = [];
    widthChangeEventSubject = new Subject<any>();

    @Input() workflowId: any = undefined;
    @Input() metaData: any;

    dagSourceModel: DagSourceModel;
    constructor(
        private _workflowHttpService: WorkflowhttpService,
    ) { }

    async ngOnInit() {
        this.dagSourceModel = new DagSourceModel();
        this.dagSourceModel.setFieldMetadata(this.metaData.fields);
        await this.getData(true);
        this.isLoading = false;
        this.fields = this.dagSourceModel.getFieldMetadata();
        this.nodeOptions = new NodeOptionsObject({
            title: this.metaData.title,
            showAddChild: false,
            isDraftMode: false,
            autosave: false,
            workflowId: this.workflowId,
            metaData: this.metaData,
            viewMode: 'audit'
        });
    }

    getData(resetPage: boolean = false) {
        return new Promise( resolve => {
            if(resetPage) {
                this.currentPage=1;
            }
            this.param = {
                page: this.currentPage,
                limit: this.pageLimit
            };
            this.param['filter'] = this.appliedViewsFilter;
            this._workflowHttpService.getAutomationAuditList(this.workflowId, this.param).subscribe( data => {
                if(data.hasOwnProperty('items')) {
                    this.auditItems = data['items'];
                    this.totalEntriesCount = data['totalCount'];
                    this.filterOptions = data['defaultFilters'];
                }
                if(this.totalEntriesCount > 0){
                    this.noData = false;
                }
                resolve(true);
            })
        });
    }

    async applyFilters(filter:any) {
        this.appliedViewsFilter.push(filter);
        await this.getData(true);
    }

    async removeFilter(filter: any) {
        this.appliedViewsFilter.splice(filter, 1);
        await this.getData(true);
    }

    voidCallingOnInit: boolean=true;
    onScrollEnd(event:any) {
        if(this.voidCallingOnInit) {
            this.voidCallingOnInit = false;
            return;
        }
        if(this.infiniteScrollOn) {
            return;
        }
        if(this.totalEntriesCount == this.auditItems.length) {
            return;
        }
        this.infiniteScrollOn = true;
        this.currentPage = this.currentPage + 1;
        this.param = {
            page: this.currentPage,
            limit: this.pageLimit
        };
        this._workflowHttpService.getAutomationAuditList(this.workflowId, this.param).subscribe( data => {
            if(data.hasOwnProperty('items')) {
                this.auditItems = this.auditItems.concat(data['items']);
                this.infiniteScrollOn = false;
            }
        })
    }

    showDiagramPreview(item) {
        console.log('item', item);
        this.selectedItem = item;
        this.isLoadingDiagramView = true;
        this._workflowHttpService.getAutomationAuditDetail(item.id)
        .subscribe(resp => {
            this.activeDagData = resp['data'];
            this.nodeOptions.audit = {
                taskId: this.activeDagData['taskId'],
                eventId: this.activeDagData['eventType'],
            };
            this.isLoadingDiagramView = false;
        })
    }
}
